import clsx from "clsx";
import { ReactElement, ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hook";
import { colors } from "../colors";
import { Breadcrumb } from "../organisms/breadcrumb/index";
import { HeaderComponent } from "../organisms/header/index";
import { HeadingSize } from "../organisms/heading/dto";
import { HeadingComponent } from "../organisms/heading/index";
import { MenuItems } from "../organisms/sidebar/dto";
import SidebarComponent from "../organisms/sidebar/index";
import { MenuStatus } from "./dto";
import { setMenuStatus } from "./slice";

interface Props {
    menuItem: MenuItems
    children: ReactNode
    headingLabel: string | ReactElement
    headingSubLabel?: string
    headingButtons: ReactElement[]
    breadcrumbItems: string[]
    breadcrumbIcon: ReactElement
    showSpinner?: boolean
}

export function LayoutComponent(props: Props) {
    const { menuItem } = props
    const { children } = props
    const { headingLabel } = props
    const { headingSubLabel } = props
    const { headingButtons } = props
    const { breadcrumbItems } = props
    const { breadcrumbIcon } = props
    const { showSpinner } = props

    const layoutState = useAppSelector(state => state.layout)
    
    const [previousMenuStatus, setPreviousMenuStatus] = useState(layoutState.menuStatus);

    useEffect(() => {
        setPreviousMenuStatus(layoutState.menuStatus);
    }, [layoutState.menuStatus]);

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    return (
        <div
            className={`antialiased min-h-screen bg-white text-neutral-100 max-h-screen flex`}
        >
            <div
                onMouseEnter={() => {
                    if (layoutState.menuStatus === MenuStatus.CLOSED) {
                        dispatch(setMenuStatus(MenuStatus.HOVER))
                    }
                }}
                onMouseLeave={() => {
                    if (layoutState.menuStatus === MenuStatus.HOVER) {
                        dispatch(setMenuStatus(MenuStatus.CLOSED))
                    }
                }}
                className={clsx(
                    "border-white border-r-[1px] hidden lg:block z-[50] flex-shrink-0",
                    {
                        "w-[240px] transition-all":
                            layoutState.menuStatus === MenuStatus.OPEN || layoutState.menuStatus === MenuStatus.HOVER,
                        "w-[72px] transition-all":
                            layoutState.menuStatus === MenuStatus.CLOSED && previousMenuStatus !== MenuStatus.HOVER,
                        "absolute h-[100%] bg-white":
                            layoutState.menuStatus === MenuStatus.HOVER,
                    }
                )}>
                <SidebarComponent menuItem={menuItem} />
            </div>
            <div
                className={
                    clsx(
                        "border-white border-r-[1px] transition-all lg:hidden"
                    )
                }>
                <div
                    className="w-[100%] h-[100%] backdrop-blur-sm transition-all"
                    onClick={() => {
                        dispatch(setMenuStatus(MenuStatus.CLOSED))
                    }}
                >
                    <div
                        className={clsx("w-[240px] h-[100%] bg-white opacity-100 transition-all", /* {
                            'w-[72px]': isTabletOrMobile
                        } */
                        )}
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                        }}
                    >
                        <SidebarComponent menuItem={menuItem} />
                    </div>
                </div>
            </div>
            <div
                style={{
                    flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'auto'
                }}
                className={
                    clsx(
                        "",
                        {
                            'ml-[0px] lg:ml-[72px]': layoutState.menuStatus === MenuStatus.HOVER,
                            'transition-all ml-[0px]': layoutState.menuStatus !== MenuStatus.HOVER,
                        }
                    )
                }
            >
                <div
                    style={{ backgroundColor: 'white', padding: "0px 24px 24px 24px", flexGrow: 1 }}
                >
                    <div
                        style={{ minHeight: '68px', backgroundColor: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}
                    >
                        <div>
                            <Breadcrumb items={breadcrumbItems} icon={breadcrumbIcon} />
                        </div>
                        <div>
                            <HeaderComponent />
                        </div>
                    </div>
                    <div
                        style={{
                            padding: '24px',
                            backgroundColor: colors.white,
                            borderRadius: '24px',
                            boxShadow: 'rgb(28 30 33 / 5%) 0px 1px 10px 10px',
                            marginLeft: 0,
                            minHeight: 'calc(100vh - 98px)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 12,
                        }}
                    >
                        <HeadingComponent
                            label={headingLabel}
                            buttons={headingButtons}
                            subLabel={headingSubLabel}
                            size={HeadingSize.LG}
                        />
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}
